<script setup lang="ts">
import WordleBoardCell from "@/components/wordle/WordleBoardCell.vue";
import type { WordleGameState } from "@kekkle/shared/types/fields/wordle-game-state/wordle-game-state";

type Props = {
  gameState: WordleGameState;
  invalidWord: boolean;
  currentRow: number;
};

defineProps<Props>();
</script>
<template>
  <div class="relative flex w-full flex-col gap-1">
    <transition name="opacity">
      <p
        v-if="invalidWord"
        style="transform: translate(-50%, -50%)"
        class="absolute left-1/2 z-10 w-max rounded-sm bg-kekkle-dark-dark px-2 py-2 text-sm text-white"
      >
        Geen goed woord
      </p>
    </transition>
    <div
      v-for="(row, rowIndex) in gameState"
      :key="rowIndex"
      class="flex w-full flex-nowrap justify-center gap-1"
      :class="invalidWord && currentRow === rowIndex ? 'shake' : ''"
    >
      <WordleBoardCell
        v-for="(cell, cellIndex) in row"
        :key="'cell-' + cellIndex"
        :letter="cell"
        :index="cellIndex"
      />
    </div>
  </div>
</template>
<style scoped>
@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

.shake {
  animation: horizontal-shaking 0.5s;
}

.opacity-enter-active {
  transition: opacity 0.2s ease;
}
.opacity-leave-active {
  transition-delay: 1s;
  transition: opacity 1s ease;
}

.opacity-enter-from,
.opacity-leave-to {
  opacity: 0;
}
</style>
